import { useEffect, useRef } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useAuth, useSession, useSignIn } from '@clerk/clerk-react'
import Loading from '@/components/Loading'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'

function SsoToken() {
  const { signInToken } = Route.useSearch()
  const { signIn, setActive, isLoaded } = useSignIn()
  const { signOut } = useAuth()
  const { isSignedIn, session, isLoaded: isSessionLoaded } = useSession()
  const ran = useRef(false)
  useRedirectToLastUrl()

  useEffect(() => {
    if (!isLoaded || !isSessionLoaded || !signIn || !setActive || !signInToken || isSignedIn || ran.current) {
      return
    }

    const createSignIn = async () => {
      try {
        if (isSignedIn) {
          await signOut()
          await (session as any)?.remove()
          await setActive({ session: null })
        }

        const signInAttempt = await signIn.create({
          strategy: 'ticket',
          ticket: signInToken,
        })

        if (signInAttempt.status === 'complete') {
          await setActive({ session: signInAttempt.createdSessionId })
        } else {
          console.error('Sign in attempt failed')
        }
      } catch (err) {
        console.error('SSO Token Error', JSON.stringify(err, null, 2))
      }
    }

    void createSignIn()
    ran.current = true
  }, [signIn, setActive, signInToken, isLoaded, isSessionLoaded, isSignedIn])

  return <Loading />
}

export const Route = createFileRoute('/sso-token')({
  validateSearch: (search: Record<string, unknown>) => ({
    signInToken: search.signInToken as string | undefined,
  }),
  component: SsoToken,
})
